import {Injectable} from '@angular/core';

import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Domain} from 'classes/domain';

import {environment} from 'environment';

@Injectable()
export class VoucherDomainsRepository {

  constructor(private http: Http) { }

  public getAllDomains(): Observable<Array<Domain>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(environment.domains, options)
            .map((response: Response) => {
              return response.json();
            });
  }

  public saveNewDomain(name: string): Observable<Domain> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify({name: name});

    return this.http.post(`${environment.domains}`, body, options)
            .map((response: Response) => {
              return response.json();
            });
  }

  public updateDomain(id: number, name: string): Observable<Domain> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify({name: name});

    return this.http.put(`${environment.domains}/${id}`, body, options)
            .map((response: Response) => {
              return response.json();
            });
  }

  public deleteDomain(id: number): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.domains}/${id}`, options)
            .map((response: Response) => {
              return response.ok;
            });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-domains/repositories/voucher-domains.repository.ts